import {Routes} from '@angular/router';

import {DashboardAdminPageComponent} from './component/page/admin/dashboard/dashboard.component';
import {ManageAdminPageComponent} from './component/page/admin/manage/manage.component';
import {PeoAdminPageComponent} from './component/page/admin/peo/peo.component';
import {SignInAdminPageComponent} from './component/page/admin/sign-in/sign-in.component';
import {SignOutAdminPageComponent} from './component/page/admin/sign-out/sign-out.component';
import {NotFoundPageComponent} from './component/page/not-found/not-found.component';
import {SignOutEmployeePageComponent} from './component/page/employee/sign-out/sign-out.component';
import {SsoEmployeePageComponent} from './component/page/employee/sso/sso.component';

import {AdministratorGuard} from './guard/administrator.guard';
import {EmployeeGuard} from './guard/employee.guard';
import {
  PeoApiCredentialTestAdminPageComponent
} from './component/page/admin/peo-api-credential-test/peo-api-credential-test.component';
import {PeoClientAdminPageComponent} from './component/page/admin/peo-client/peo-client.component';
import {ImportWizardAdminPageComponent} from './component/page/admin/import-wizard/import-wizard.component';

/**
 * @constant
 * @description This constant provides the routes for the application.
 * @export
 * @name routes
 * @type {Routes}
 */
export const routes: Routes = [
  {component: DashboardAdminPageComponent, path: 'admin/dashboard', canActivate: [AdministratorGuard]},
  {component: ImportWizardAdminPageComponent, path: 'admin/import/wizard', canActivate: [AdministratorGuard]},
  {component: ManageAdminPageComponent, path: 'admin/manage', canActivate: [AdministratorGuard]},
  {component: PeoAdminPageComponent, path: 'admin/peo', canActivate: [AdministratorGuard]},
  {component: PeoClientAdminPageComponent, path: 'admin/peo/client', canActivate: [AdministratorGuard]},
  {component: PeoClientAdminPageComponent, path: 'admin/peo/:peoId/client', canActivate: [AdministratorGuard]},
  {
    component: PeoApiCredentialTestAdminPageComponent,
    path: 'admin/peo/api-credential-test',
    canActivate: [AdministratorGuard]
  },
  {component: SignInAdminPageComponent, path: 'admin/sign-in'},
  {component: SignOutAdminPageComponent, path: 'admin/sign-out', canActivate: [AdministratorGuard]},
  {component: SignOutEmployeePageComponent, path: 'sign-out'},
  {component: SsoEmployeePageComponent, path: 'sso', canDeactivate: [EmployeeGuard]},
  {component: NotFoundPageComponent, path: ''},
  {component: NotFoundPageComponent, path: '**'},
];
